import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=0f20311c&scoped=true&"
import script from "./AlertBar.vue?vue&type=script&lang=js&"
export * from "./AlertBar.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=0f20311c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20311c",
  null
  
)

export default component.exports